export const SET_FILTERS = (state, filters) => {
  state.filters = {
    ...state.filters,
    ...filters
  }
}
